import { type ReactNode } from 'react';
import { cn } from './cn';

export interface SegmentedItem<T extends string = string> {
  value: T;
  label: ReactNode;
}

export interface SegmentedControlProps<T extends string = string> {
  value: T;
  onChange: (value: T) => void;
  items: SegmentedItem<T>[];
  ariaLabel?: string;
  className?: string;
}

export function SegmentedControl<T extends string = string>({
  value,
  onChange,
  items,
  ariaLabel,
  className,
}: SegmentedControlProps<T>) {
  return (
    <div role="radiogroup" aria-label={ariaLabel} className={cn('ui-segmented', className)}>
      {items.map(item => {
        const isSelected = item.value === value;
        return (
          <button
            key={item.value}
            type="button"
            role="radio"
            aria-checked={isSelected}
            className={cn('ui-segmented__item', isSelected && 'ui-segmented__item--active')}
            onClick={() => onChange(item.value)}
          >
            {item.label}
          </button>
        );
      })}
    </div>
  );
}
